import { type } from "@testing-library/user-event/dist/type";
import { FORGET_ME, REMEMBER_ME, LOGIN_SUCCESS, LOGOUT } from "../constants/Constants";

export const rememberMe = (username, password) => ({
  type: REMEMBER_ME,
  payload: { username, password },
});

export const forgetMe = () => ({
  type: FORGET_ME,
});

export const loginSuccess = (token) => ({
  type: LOGIN_SUCCESS,
  payload: token,
});

export const logout = () => ({
  type: LOGOUT,
});

